import { styled } from '@mui/material/styles';
import { globalZindex } from 'core/common/constants';
import { applicationSidePaddingPx } from 'core/theme/constants';

export const HeaderStyled = styled('header')`
  z-index: ${globalZindex.content};
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 6px ${applicationSidePaddingPx}px;
`;
